/**
 * Safe date formatter — evita crash React (blue screen) su date invalide.
 * date-fns `format(new Date(v), ...)` lancia `RangeError: Invalid time value`
 * quando `v` è null / undefined / stringa malformata / numero. Questo helper
 * gestisce tutti i casi e restituisce un fallback (default: '-').
 */
import { format, parseISO, isValid } from 'date-fns';
import { it } from 'date-fns/locale';

const DEFAULT_LOCALE = { locale: it };

/**
 * fmtDate(value, formatStr, fallback?)
 *  - value: string ISO (`2026-01-15` o `2026-01-15T10:00:00Z`), Date, number, null, undefined
 *  - formatStr: pattern date-fns (es. `dd-MM-yyyy`)
 *  - fallback: valore renderizzato se la data non è parsabile (default `-`)
 */
export const fmtDate = (value, formatStr = 'dd-MM-yyyy', fallback = '-') => {
  if (value == null || value === '') return fallback;
  try {
    let d;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === 'string') {
      // Prima prova parseISO (più tollerante e safer)
      d = parseISO(value);
      if (!isValid(d)) d = new Date(value);
    } else if (typeof value === 'number') {
      d = new Date(value);
    } else {
      return fallback;
    }
    if (!isValid(d)) return fallback;
    return format(d, formatStr, DEFAULT_LOCALE);
  } catch (_err) {
    return fallback;
  }
};

export default fmtDate;
